import React, { Component } from "react";
import Modal from "react-modal";
import "../common.css";
import { MdClose } from "react-icons/md";
import config from "../../config";
import errorFunctions from "../../store/errorFunctions";
import utilityFunctions from "../../store/utilityFunctions";
import Select from "react-select";

import axios from "axios";
// import Select from "react-select";
// import { postNewStaffFunction } from "./api";

Modal.setAppElement("body");
const countryOptions = [
  { value: "AU", label: "Australia" },
  { value: "NZ", label: "New Zealand" },
];

export default class ServiceCenterSettingAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      redirect: false,
      statusTicket: "",
      modalStatusConfirm: false,
      brands: [],
      roles: [],
      currentRole: "",
      serviceCenterOptions: null,
      serviceCenterValue: this.props.serviceCenterValue,
      locationOptions: null,
      locationValue: this.props.locationValue,
      siteValue: this.props.siteValue,

      postError: "",
      countryValue: countryOptions.find((c) => c.value === config.country),
    };
  }

  componentDidMount() {
    this.retrieveServiceCenter();
  }
  serviceCenterChange = (sc) => {
    const locationOptions = this.state.serviceCenters
      .find((s) => s.id === sc.value)
      ?.service_centers.map((loc) => {
        return { value: loc.id, label: loc.name };
      });
    this.setState({ serviceCenterValue: sc, locationOptions });
  };

  siteChange = (sc) => {
    this.setState({ siteValue: sc });
  };

  retrieveServiceCenter = () => {
    this.setState({ loading: true });
    utilityFunctions
      .protectedFetch(config.backendServer + "service_center_centrals/", "GET", null, errorFunctions.checkResponseThenJson)
      .then((res) => {
        const serviceCentrals = res.filter((sc) => sc.country === this.state.countryValue.value);
        const serviceCenterOptions = res
          .filter((sc) => sc.country === config.country)
          ?.map((sc) => {
            return { value: sc.id, label: sc.name };
          });
        this.setState({
          loading: false,
          serviceCenters: res,
          serviceCenterOptions,

          serviceCenterCentralId: serviceCentrals[0].id,
        });
        if (this.state.serviceCenterValue) {
          const locationOptions = serviceCentrals
            .find((s) => s.id === this.state.serviceCenterValue.value)
            ?.service_centers.map((loc) => {
              return { value: loc.id, label: loc.name };
            });

          this.setState({ locationOptions });
        }

        // this.retrieveServiceCenter(serviceCentrals[0].id);
      })
      .catch(() => {
        console.log("fail");
        this.setState({ loading: false });
      });
  };

  addServiceCenterSetting = (payload) => {
    const userInfo = localStorage?.getItem("userInfo") || utilityFunctions?.getCookie("userInfo");
    const token = (userInfo && JSON?.parse(userInfo)?.access_token) || "";
    let options = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    return new Promise((resolve) => {
      axios
        .post(`${config.backendServer}default-service-center/`, payload, options)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          resolve(err);
        });
    });
  };

  updateServiceCenterSetting = (payload) => {
    const userInfo = localStorage?.getItem("userInfo") || utilityFunctions?.getCookie("userInfo");
    const token = (userInfo && JSON?.parse(userInfo)?.access_token) || "";
    let options = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    return new Promise((resolve) => {
      axios
        .patch(`${config.backendServer}default-service-center/${this.props.serviceCenterValue.value}/`, payload, options)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          resolve(err);
        });
    });
  };

  handleSubmit = async (event) => {
    this.setState({ loading: true });
    event.preventDefault();

    let payload = {
      country: this.state.countryValue.value,
      site_domain: config.baseUrl,
      service_center_central: this.state.serviceCenterValue.value,
      service_center: this.state.locationValue.value,
    };

    const result = this.props.serviceCenterValue.value ? await this.updateServiceCenterSetting(payload) : await this.addServiceCenterSetting(payload);
    if (result.status === 200 || result.status === 201) {
      this.setState({ loading: false });
      this.props.closeModal();
      this.props.retrieveDefaultServiceCenter();
    } else {
      this.setState({
        loading: false,
        postError: JSON.stringify(result?.response?.data),
      });
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  render() {
    return (
      <div className={"card"} style={{ height: "100%" }}>
        <button onClick={() => this.props.closeModal()} className={"confirm-modal-close"}>
          <MdClose />
        </button>
        <div className={"card-header"}>
          <h4>{`${this.state.serviceCenterValue.value ? "Edit Service Center" : "Add Service Center"} `}</h4>
        </div>

        <form onSubmit={this.handleSubmit}>
          <div className="card-body m-3">
            <div className="mb-3">
              <label className={"single-warranty-details-label "} htmlFor="name">
                Service Center*
              </label>
              <Select
                isDisabled={Boolean(this.props.serviceCenterValue.value)}
                data-testid="assign-to-select"
                isSearchable={true}
                options={this.state.serviceCenterOptions}
                value={this.state.serviceCenterValue}
                onChange={(sc) => this.serviceCenterChange(sc)}
              />
            </div>
            <div className="mb-3">
              <label className={"single-warranty-details-label"}>Location*</label>
              <Select
                data-testid="assign-to-select"
                isSearchable={true}
                options={this.state.locationOptions}
                value={this.state.locationValue}
                onChange={(sc) => this.setState({ locationValue: sc })}
              />
            </div>
            <div className="mb-3">
              <label className={"single-warranty-details-label"}>Site</label>
              <input className="form-control " value={config.baseUrl} disabled />
            </div>

            <div className="mb-3">
              <label className={"single-warranty-details-label"}>Country</label>
              <input className="form-control " value={this.state.countryValue.label} disabled />
            </div>
          </div>
          <div className="card-footer ">
            <div className="d-flex justify-content-start gap-2">
              <button className={"btn btn-outline-primary"}>Submit</button>
              <button type="button" className={"btn btn-outline-secondary"} onClick={() => this.props.closeModal()}>
                Close
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}
